export const jiraProductIds = ['jira-software', 'jira', 'jira-core'];

export const hasJiraProducts = (selectedProducts: string[]): boolean => {
	return selectedProducts.some(product => jiraProductIds.includes(product));
};
